import Link from "next/link";
import { FaWhatsapp } from "react-icons/fa";

export default function WhatsAppButton() {
  const whatsappNumber = "1234567890";

  return (
    <Link
      href={`https://wa.me/${whatsappNumber}`}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        position: "fixed",
        bottom: "85px",
        right: "30px",
        backgroundColor: "#25D366",
        zIndex: 1000,
      }}
      className="
      text-white 
        rounded-circle 
        d-flex align-items-center justify-content-center
        shadow-lg
        p-0 
        
      "
      aria-label="Chat with us on WhatsApp"
    >
      <div
        style={{ width: "50px", height: "50px" }}
        className="d-flex align-items-center justify-content-center" 
      >
        <FaWhatsapp size={28} color="#ffffff" />
      </div>
    </Link>
  );
}